import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { fetchDonationTypeApi } from "../../../Api/DonationTypes";
import { fetchPurposeApi } from "../../../Api/DonationPurpose";
import { getAllBankApi } from "../../../Api/Bank";
import { getUserByRoleType } from "../../../Api/user";

interface UserBank {
    id: string;
    label: string;
    name: string;
    accountNumber: number;
}
interface Balance {
    url: string;
    BalanceTransfer: any[]
}

export const BalanceTransferAssigned = ({ url, BalanceTransfer }: Balance) => {
    const [allusersdata, setUserdetaildata] = useState<UserBank[]>([]);
    const [allbankdata, setBankdetaildata] = useState<UserBank[]>([]);
    const [donationType, setDonationType] = useState<Record<string, string>>({});
    const [donationPurpose, setDonationPurpose] = useState<Record<string, string>>({});

    useEffect(() => {
        if (!url) return;
        
        const fetchAllTaxonomies = async () => {
            try {
                const [typeResponse, purposeResponse] = await Promise.all([
                    fetchDonationTypeApi(url) as Promise<{ id: string; name: string }[]>,
                    fetchPurposeApi(url) as Promise<{ id: string; name: string }[]>,
                ]);
                setDonationType(
                    typeResponse.reduce((acc: Record<string, string>, item: any) => {
                        acc[item.id] = item.name;
                        return acc;
                    }, {})
                );

                setDonationPurpose(
                    purposeResponse.reduce((acc: Record<string, string>, item: any) => {
                        acc[item.id] = item.name;
                        return acc;
                    }, {})
                );
            } catch (error) {
                toast.error("Failed to load donation types and purposes");
            }
        };

        fetchAllTaxonomies();
    }, [url]);

    const TransferAccountValue = (typeId: string, isBank: boolean) => {
        if (!typeId) return "N/A";

        const data = isBank ? allbankdata : allusersdata;
        const transfer = data.find((t) => t.id.toString() === typeId);

        if (transfer) {
            return isBank
                ? `${transfer.name} - ${transfer.accountNumber}`
                : transfer.name;
        }
    };
    useEffect(() => {
        async function fetchData() {
            try {
                const [userData, bankData] = await Promise.all([
                    getUserByRoleType(2, url),
                    getAllBankApi(url),
                ]);

                setUserdetaildata(
                    userData.map((user: any) => ({
                        id: user.id,
                        name: user.name,
                        label: user.name,
                    }))
                );
                setBankdetaildata(
                    bankData.map((bank: any) => ({
                        id: bank.id,
                        name: bank.name,
                        accountNumber: bank.accountNumber,
                        label: `${bank.name} - (${bank.accountNumber})`,
                    }))
                );
            } catch (error) {
                toast.error("Failed to fetch data.");
            }
        }
        fetchData();
    }, [url]);


    return (
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
            <thead className="bg-gray-50 dark:bg-gray-800">
                <tr>
                    <th
                        scope="col"
                        className="py-3.5 px-4 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                    >
                        <span>From</span>
                    </th>
                    <th
                        scope="col"
                        className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                    >
                        <span>To</span>
                    </th>
                    <th
                        scope="col"
                        className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                    >
                        <span>Donation Type</span>
                    </th>
                    <th
                        scope="col"
                        className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                    >
                        <span>Donation Purpose</span>
                    </th>
                    <th
                        scope="col"
                        className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                    >
                        <span>Transfered On</span>
                    </th>
                    <th
                        scope="col"
                        className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                    >
                        <span>Amount</span>
                    </th>
                </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                {BalanceTransfer.map((balanceTransfer: any) => (
                    <tr key={balanceTransfer.id}>
                        <td className={`px-4 py-4 text-sm font-medium text-gray-500`}>
                            {TransferAccountValue(
                                balanceTransfer.transferAccountFrom,
                                balanceTransfer.transferFrom === "Bank"
                            )}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-500 dark:text-gray-300 whitespace-nowrap">
                            {TransferAccountValue(
                                balanceTransfer.transferAccountTo,
                                balanceTransfer.transferTo === "Bank"
                            )}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-500 dark:text-gray-300 whitespace-nowrap">
                            {donationType[balanceTransfer.donationTypeId]}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-500 dark:text-gray-300 whitespace-nowrap">
                            {donationPurpose[balanceTransfer.donationPurposeId]}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-500 dark:text-gray-300 whitespace-nowrap">
                            {new Date(balanceTransfer.transferedOn).toLocaleDateString(
                                "en-GB",
                                {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                }
                            )}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-500 dark:text-gray-300 whitespace-nowrap">
                            {balanceTransfer.amount}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

